import { render } from "./OurContact.vue?vue&type=template&id=71565cd8&scoped=true"
import script from "./OurContact.vue?vue&type=script&lang=js"
export * from "./OurContact.vue?vue&type=script&lang=js"

import "./OurContact.vue?vue&type=style&index=0&id=71565cd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71565cd8"]])

export default __exports__